import React, { useState } from 'react'
import {Field, ErrorMessage} from "formik";
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

// const TextField = ({form, field, label_text, helper_text, password, isDisabled, type}) => {
//     return (
//         <>
//             <div>
//                 {
//                     label_text&&
//                     <label htmlFor="fname" className={"text-sm font-medium inline-block"}>{label_text}</label>
//                 }
//                 <Field 
//                     as={"input"}
//                     type={type ? type : "text"}
//                     name={field}
//                     id={field}
//                     disabled={isDisabled}
//                     placeholder={helper_text ? helper_text : ""}
//                     className={`resize-none h-[50px] disabled:bg-gray-100 disabled:cursor-not-allowed input-text ${form.touched[field] && form.errors[field] ? "input-text-error" : ""} ${form.values[field] && form.values[field].toString().length > 0 && "input-text-active"}`}
//                 />
//                 <p className="text-xs text-red-500">
//                     <ErrorMessage name={field} />
//                 </p>
//             </div>
//         </>
//     )
// }

// export default TextField

const TextField = ({form, field, label_text, helper_text, isDisabled, type, Icon,isRequired}) => {

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    return (
        <>
            <div>
                {
                    label_text&&
                    <label htmlFor="fname" className={"text-xs font-medium inline-block"}>{label_text}{isRequired && <span className=''>*</span>}</label>
                }
                <div className='relative flex items-center'>
                    {
                        Icon &&
                        <Icon className="absolute left-3 text-t-light" />
                    }
                <Field 
                    as={"input"}
                    type={type === 'password' ? (showPassword ? 'text' : 'password') : type ? type : 'text'}
                    name={field}
                    id={field}
                    disabled={isDisabled}
                    placeholder={helper_text ? helper_text : ""}
                    className={`resize-none h-[45px]  disabled:bg-gray-100 disabled:cursor-not-allowed input-text ${form.touched[field] && form.errors[field] ? "input-text-error" : ""} 
                    ${form.values[field] && form.values[field].toString().length > 0 && "input-text-active"}
                    ${Icon ? "!pl-8" : ""}`}
                />
                {type === 'password' && (
                        <div
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="absolute right-3 text-t-light focus:outline-none text-[20px]"
                        >
                            {!showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                        </div>
                    )}
                </div>
                <p className="text-xs text-red-500">
                    <ErrorMessage name={field} />
                </p>
            </div>
        </>
    )
}

export default TextField